// Local time: shows the current time (with seconds) in data-time-zone (e.g. America/Los_Angeles), refreshed each second.
class LocalTime extends HTMLElement {
  #timer = 0;

  connectedCallback() {
    const timeZone = this.dataset.timeZone || 'America/Los_Angeles';
    let format;
    try {
      format = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', {
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        timeZone,
      });
    } catch {
      return;
    }
    const render = () => {
      this.textContent = format.format(new Date());
    };
    render();
    this.#timer = window.setInterval(render, 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }
}

if (!customElements.get('s-local-time')) customElements.define('s-local-time', LocalTime);
